import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MppStarRatingComponent } from './star-rating.component';

@NgModule({
  imports: [CommonModule],
  declarations: [MppStarRatingComponent],
  exports: [MppStarRatingComponent],
})
export class MppStarRatingModule {}
